import Model from './Model';
import Collection from './Collection';

export class Override extends Model {

	defaults() {
		return {
			id: null,
			projectId: null,
			priority: null,
			filterModelType: null,
			filterModelId: null,
			overrideModelType: null,
			attribute: null,
			value: null,
		};
	}

	routes() {
		return {
			create: 'overrides',
			patch: 'overrides/{id}',
			delete: 'overrides/{id}',
		};
	}

	options() {
		return {
			patch: true,
		};
	}

}

export class Overrides extends Collection {

	model() {
		return Override;
	}

	routes() {
		return {
			fetch: 'overrides?projectId={projectId}',
		};
	}

}
